export default __webpack_public_path__ + "static/mobile_KV16-b607e5e454a609b14b7ada694a6b49be.mp4";